import axiosInstance from "../Interceptors/ResponseInterceptor";

export function getSiteReport(page, pageSize, columnFilters = []) {
  return new Promise(async (resolve, reject) => {
    try {
      const filters = JSON.stringify(columnFilters ?? []);
      const response = await axiosInstance.get(
        `/api/reports/current-stage?page=${page}&pageSize=${pageSize}&filters=${filters}`
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in fetching City-Wise Site Status:", error);
      reject(error);
    }
  });
}

export function getPendingSiteReport(page, pageSize, columnFilters = []) {
  return new Promise(async (resolve, reject) => {
    try {
      const filters = JSON.stringify(columnFilters ?? []);
      const response = await axiosInstance.get(
        `/api/reports/pending-stage?page=${page}&pageSize=${pageSize}&filters=${filters}`
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in fetching OMC-Wise Pendency reports:", error);
      reject(error);
    }
  });
}

export function getStatusSearchReport(page, pageSize, columnFilters = []) {
  return new Promise(async (resolve, reject) => {
    try {
      const filters = JSON.stringify(columnFilters ?? []);
      const response = await axiosInstance.get(
        `/api/reports/pendent-sites?page=${page}&pageSize=${pageSize}&filters=${filters}`
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in fetching City-Wise Site Status:", error);
      reject(error);
    }
  });
}
